import {withHandlers} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'

import withHook from '../../../../../hocs/withHook'
import type {State} from '../../../../../reducers/types'
import {getAgent, getIsAgentTypeManageable} from '../../../../../selectors'
import type {User} from '../../../../../services/rest'
import {restApi} from '../../../../../services/rest'
import type {AgentId, AgentPoolId} from '../../../../../types'
import {BS} from '../../../../../types/BS_types'

import AgentToggle from './AgentToggle'

type OwnProps = {
  agentId: AgentId
  className?: string
}
type StateProps = {
  poolId?: AgentPoolId
  isAgentTypeManageable: boolean
  isCloud: boolean
  enabled: boolean
  connected: boolean
  commentText: string | null | undefined
  commentTimestamp: string | null | undefined
  commentUser: User | undefined
}
type ConnectProps = OwnProps & StateProps

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const {
    pool,
    enabled = false,
    connected = false,
    enabledInfo,
    typeId,
    cloudInstanceId,
  } = getAgent(state, props.agentId) || {}

  const comment = enabledInfo?.comment
  const isAgentTypeManageable = typeId != null && getIsAgentTypeManageable(state, typeId)
  return {
    commentText: comment?.text,
    commentUser: comment?.user,
    commentTimestamp: comment?.timestamp,
    poolId: pool?.id,
    isAgentTypeManageable,
    isCloud: cloudInstanceId != null,
    enabled,
    connected,
  }
}

export default compose(
  connect(mapStateToProps, {}),
  withHandlers({
    handleToggleClick:
      ({agentId, enabled, connected}: ConnectProps) =>
      () => {
        BS?.Agent?.showChangeStatusDialog(
          !enabled,
          agentId,
          connected,
          'changeAgentStatus',
          undefined,
          () => {
            BS?.AgentsReact?.refreshFetcherData()
          },
        )
      },
  }),
  withHook(({poolId, isAgentTypeManageable}: ConnectProps) => {
    const {isToggleable} = restApi.endpoints.getPoolPermissions.useQuery(undefined, {
      selectFromResult: ({data}) => ({
        isToggleable: poolId != null && data?.[poolId]?.canChangeStatus,
      }),
    })
    return {isToggleable: isToggleable && isAgentTypeManageable}
  }),
)(AgentToggle)
